(function() {
  'use strict';

  function updateButtonVisibility(swiperInstance, blockElement) {
    const prevButton = blockElement.querySelector('.swiper-button-prev');
    const nextButton = blockElement.querySelector('.swiper-button-next');
    
    if (prevButton) {
      prevButton.style.display = swiperInstance.isBeginning ? 'none' : 'flex';
    }
    
    if (nextButton) {
      nextButton.style.display = swiperInstance.isEnd ? 'none' : 'flex';
    }
  }

  function initVideoSliders() {
    const videoSliderBlocks = document.querySelectorAll('.product-video-slider-block[data-block-id]');
    
    videoSliderBlocks.forEach(function(block) {
      const swiperContainer = block.querySelector('.product-video-slider-block__swiper');
      
      if (!swiperContainer || swiperContainer.swiper) return;

      const spaceBetween = parseInt(block.getAttribute('data-space-between')) || 20;

      const swiper = new Swiper(swiperContainer, {
        slidesPerView: 2.3,
        spaceBetween: spaceBetween,
        slidesPerGroup: 1,
        a11y: false,
        watchSlidesProgress: true,
        loop: false,
        fade: false,
        navigation: {
          nextEl: block.querySelector('.swiper-button-next'),
          prevEl: block.querySelector('.swiper-button-prev'),
        },
        on: {
          init: function() {
            updateButtonVisibility(this, block);
          },
          slideChange: function() {
            updateButtonVisibility(this, block);
          },
          resize: function() {
            updateButtonVisibility(this, block);
          }
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: spaceBetween,

          },
          576: {
            slidesPerView: 2,
            spaceBetween: spaceBetween,
          },
          767: {
            slidesPerView: 2,
            spaceBetween: spaceBetween,
          },
          990: {
            slidesPerView: 2.3,
            spaceBetween: spaceBetween,
          },
        },
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVideoSliders);
  } else {
    initVideoSliders();
  }

  if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initVideoSliders);
    document.addEventListener('shopify:block:select', initVideoSliders);
  }
})();
